import { differenceInCalendarDays } from "date-fns";

export const isDocumentExpiring = (expiry: string | Date, inDays = 42) => {
  const expiryDate = typeof expiry === "string" ? new Date(expiry) : expiry;
  const days = differenceInCalendarDays(expiryDate, new Date());

  return days >= 0 && days <= inDays;
};

export const isDocumentExpired = (expiry: string | Date) => {
  const expiryDate = typeof expiry === "string" ? new Date(expiry) : expiry;
  return differenceInCalendarDays(expiryDate, new Date()) < 0;
};
